module.exports = __webpack_public_path__ + "static/img/t5_2.88b23e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/t5_2.jpg
// module id = EVeZ
// module chunks = 0